import { IAddNotePayload, INote, INotePayload, NoteDrawerMode } from "models/notes"
import { useEffect, useState } from "react";
import { DrawerFooter, IUserNotesTag } from "@sagecentral/core-ui";
import { RichEditor, MentionFeedObjectItem } from "@sagecentral/ckeditor";
import useSearchUsers from "hooks/notes/useSearchUsers";
import { Box, styled } from "@mui/material";

type NoteEditProps = {
    mode: NoteDrawerMode;
    sourceNote?: INote | null;
    draft?: boolean;
    onClose: () => void;
    onSave: (mode: NoteDrawerMode, payload: INotePayload | IAddNotePayload, noteId?: number) => void;
};

const StyledDrawerFooter = styled(DrawerFooter)({
    height: '20px',
});

const NoteEdit: React.FC<NoteEditProps> = (props) => {
    const {
        mode,
        sourceNote,
        draft,
        onClose
    } = props;

    const [payload, setPayload] = useState<INotePayload | IAddNotePayload>({
        note: '',
        typeId: 1
    });
    const [noteIsInValid, disablePost] = useState(false);
    const fetchUsers = useSearchUsers();

    useEffect(() => {
        setPayload({
            ...payload,
            note: mode === 'edit' ? sourceNote?.note ?? '' : '',
            parentNoteId: sourceNote?.parentId ?? sourceNote?.id,
            quotedNoteId: sourceNote?.parentId ? sourceNote?.id : undefined
        })
    }, [sourceNote, mode]);

    const handleSave = () => {
        props.onSave(mode, payload, mode === 'edit' ? sourceNote?.id : undefined);
    };
    const handleChange = (event: any, editor: any) => {
        var data = editor.getData();
        var noteIsEmpty = data.length == 0;
        disablePost(noteIsEmpty);

        if (noteIsEmpty) {
            return;
        }

        let taggedUserIds: string[] | undefined = undefined;
        editor.model.change((writer: any) => {
            const range = writer.createRangeIn(editor.model.document.getRoot()!);

            for (const value of range.getWalker()) {
                const attr = value.item.getAttribute('mention') as IUserNotesTag;
                if (attr) {
                    if (taggedUserIds === undefined) {
                        taggedUserIds = [];
                    }

                    const index = taggedUserIds.findIndex(id => id === attr.id);
                    if (index === -1) {
                        taggedUserIds.push(attr.id.replace('@', ''));
                    }
                }
            }
        });

        if (taggedUserIds) {
            console.log('Tagged users', taggedUserIds);
        }

        setPayload({
            ...payload,
            note: data,
            taggedUserIds
        })
    };
    const editorReady = (editor: any) => {
        disablePost(true);
    }
    const customItemRenderer: (item: MentionFeedObjectItem) => HTMLElement = (item: MentionFeedObjectItem) => {
        const itemElement = document.createElement('div');

        itemElement.classList.add('custom-item');
        itemElement.id = `mention-list-item-id-${item.id}`;
        itemElement.textContent = `${item.text} `;

        return itemElement;
    }

    if (fetchUsers === null) {
        return null;
    }

    return (
        <Box>
            {draft &&
                <Box fontSize={'14px'} mt={'24px'}>Tagged users will not be notified until the work item has been finalized and created.</Box>
            }
            <Box>
                <RichEditor 
                    onChange={handleChange} 
                    data={payload.note} 
                    onReady={editorReady}
                    autoFocus={true} 
                    onEscape={onClose}
                    config={{
                        mention: {
                            feeds: [
                                {
                                    marker: '@',
                                    feed: fetchUsers,
                                    itemRenderer: customItemRenderer
                                }
                            ]
                        }
                    }}
                />  
                <DrawerFooter onConfirm={handleSave} onCancel={onClose} confirmText="Post" disableConfirm={noteIsInValid} styleProps={{height: '40px', width:'120px'}} />
            </Box>                      
        </Box>
    );
};

export default NoteEdit;